import PageLayoutWrapper from "components/PageLayoutWrapper";
import React from "react";
import OccupationMap from "./occupation-map";
import dayjs from "dayjs";

const Occupation = () => {
  return (
    <PageLayoutWrapper title={`Ocupação para o dia ${dayjs().format("DD-MM-YYYY")}`}>
      <OccupationMap readOnly={true} />
    </PageLayoutWrapper>
  );
};

export default Occupation;
